/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PermissionIndexResponse } from '../types/PermissionIndex'

/**
 * GET /auth/permissions
 * @see backend/nexus/modules/Authorization/Http/Controllers/PermissionController.php PermissionController::index
 */
export async function permissionIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PermissionIndexResponse>> {
	return axiosInstance.get('/auth/permissions', config)
}
